<template>
  <div class="page_bg">
    <!-- 顶部 card-->
    <div class="bg_top_linear-gradient" style="height: 7.37rem;">
      <!-- 顶部返回 -->
      <div class="back_top_name flex-c-s-c">
        <div class="top_name flex-r-sa-c">
          <div :class=" step === 1 ? 'top_step_item_1 bg_1':'top_step_item bg_2' ">
            <div class="step_index">1</div>
            <div class="top_name_item name_active">资料提交</div>
          </div>
          <van-image width="1.37rem" height="0.14rem"
                     src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/certification_top_arrow1.png"
          />
          <div v-if="step === 1" class="top_step_item bg_0">
            <div class="step_index">2</div>
            <div :class="step > 1 ? 'top_name_item name_active':'top_name_item'">审核中</div>
          </div>
          <div v-if="step === 2" class="top_step_item_1 bg_1">
            <div class="step_index">2</div>
            <div :class="step > 1 ? 'top_name_item name_active':'top_name_item'">审核中</div>
          </div>
          <div v-if="step === 3" class="top_step_item bg_2">
            <div class="step_index">2</div>
            <div :class="step > 1 ? 'top_name_item name_active':'top_name_item'">审核中</div>
          </div>
          <van-image v-if="step === 3" width="1.37rem" height="0.14rem"
                     src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/certification_top_arrow1.png"
          />
          <van-image v-else width="1.37rem" height="0.14rem"
                     src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/certification_top_arrow0.png"
          />
          <div :class=" step === 3 ? 'top_step_item_1 bg_1':'top_step_item bg_0' ">
            <div class="step_index">3</div>
            <div :class="step === 3 ? 'top_name_item name_active':'top_name_item'">审核结果</div>
          </div>
        </div>
        <div class="top_icon" />
      </div>
      <!-- 资料上传 -->
      <div v-if="step === 1" class="certification_img_box">
        <div class="certification_img_item">
          <div class="box_top flex-r-sb-c">
            <div class="img_name">营业执照 <span style="color:#ED0D0D;">*</span></div>
          </div>
          <div v-if="disabled ">
            <van-image width="6.74rem" height="3.49rem" :src="certificationForm.businessLicenseUrl" />
          </div>
          <div v-else>
            <van-uploader v-model="fileList01" :after-read="afterRead01" :max-count="1">
              <van-image v-if="fileList01.length===0" width="6.74rem" height="3.49rem"
                         src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/certification_img01.png"
              />
            </van-uploader>
            <div class="up_tip">点击上传营业执照</div>
          </div>
        </div>
        <div class="certification_img_item" style="margin-top:0.3rem">
          <div class="box_top flex-r-sb-c">
            <div class="img_name">兽药经营许可证 <span style="color: #999999;font-size: 0.29rem;">上传可获得兽药采购资格</span></div>
          </div>
          <div v-if="disabled && certificationForm.vetLicense">
            <van-image width="6.74rem" height="3.49rem" :src="certificationForm.vetLicense" />
          </div>
          <div v-else>
            <van-uploader v-model="fileList02" :after-read="afterRead02" :max-count="1">
              <van-image v-if="fileList02.length===0" width="6.74rem" height="3.49rem"
                         src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/certification_img02.png"
              />
            </van-uploader>
            <div class="up_tip">点击上传兽药经营许可证</div>
          </div>
        </div>
        <van-form class="certification_form" :disabled="disabled" @submit="onSubmit">
          <van-field v-model="certificationForm.gongshangName" label="工商名称" name="gongshangName"
                     placeholder="请输入工商名称"
          />
          <van-field v-model="certificationForm.legalPerson" label="法人姓名" name="legalPerson" placeholder="请输入法人姓名" />
          <van-field v-model="certificationForm.businessLicense" label="三证合一码" name="businessLicense"
                     placeholder="请输入三证合一码"
          />
          <van-field v-model="certificationForm.companyAddress" label="注册地址" name="businessLicense"
                     placeholder="请输入注册地址"
          />
          <!-- <van-field v-model="certificationForm.accountManager" label="客户经理" name="accountManager"
                     placeholder="请输入客户经理"
          /> -->
          <div class="certification_sub">
            <van-button round block :loading="loading" type="info" loading-text="提交中..." native-type="submit"
                        color="#0767ab" style="font-size: 0.43rem;" class="next_btn "
            >提 交 资 料
            </van-button>
          </div>
        </van-form>
      </div>
      <div v-if="step === 2" class="certification_img_box">
        <div class="certification_wait flex-c-s-c">
          <van-image width="6.4rem" height="5.26rem" fit="cover"
                     src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/certification_step_wait.png"
          />
          <div class="certification_wait_msg">审核中...</div>
          <div class="certification_wait_tips">您的资料正在审核中，请耐心等待</div>
        </div>
      </div>
      <div v-if="step === 3" class="certification_img_box">
        <div class="certification_wait flex-c-c-c">
          <van-image width="6.4rem" height="5.26rem"
                     src="https://hanxingkeji.oss-cn-shanghai.aliyuncs.com/wholesale/certification_step_faile.png"
          />
          <div class="certification_wait_msg">审核失败！</div>
          <div class="certification_wait_tips">很抱歉，您的认证信息中有部分信息未能通过审批，请修改后重申。</div>
          <div class="certification_wait_sub">
            <van-button round block :loading="loading" type="info" loading-text="提交中..." color="#0767ab"
                        style="font-size: 0.43rem;" class="next_btn " @click="resubmit"
            >再 次 申 请
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './index.scss'
import { upProToOss } from '@/utils/ali-oss-path'
import { addEnterprise, user_userInfo } from '@/api/user'
import { businessLicense } from '@/api/public'
export default {
  name: 'Certification',
  data() {
    return {
      step: 1,
      certificationShow: true,
      fileList01: [],
      fileList02: [],
      loading: false,
      certificationForm: {},
      disabled: false
    }
  },
  created() {
    this.getInfo()
    var flag = this.$store.getters.wholesaleCertificationType
    if (flag === -1) { this.step = 1 }
    if (flag === 0) { this.step = 2 }
    if (flag === 2) { this.step = 3 }
  },
  methods: {
    getInfo() {
      user_userInfo().then(res => {
        if (parseInt(res.data.wholesaleCertificationType) === 1) {
          this.disabled = true
          this.certificationForm = res.data
        }
      })
    },
    // OCR识别
    OCR(url) {
      this.$toast.loading({ message: 'OCR识别中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      businessLicense(url).then(res => {
        var vetLicense = this.certificationForm.vetLicense || ''
        this.$set(res.data, 'vetLicense', vetLicense)
        if (res.data) { this.certificationForm = res.data }
        this.$toast.clear()
      }).catch(() => {
        this.$toast.clear()
      })
    },
    // 图片上传
    afterRead01(file) {
      file.status = 'uploading'
      file.message = '上传中...'
      upProToOss(file, { product: 'wholesale-business' }).then(res => {
        this.fileList01 = []
        this.fileList01.push({ url: res, isImage: true })
        this.OCR(res)
        this.$set(this.certificationForm, 'businessLicenseUrl', res || '')
      })
    },
    // 图片上传
    afterRead02(file) {
      file.status = 'uploading'
      file.message = '上传中...'
      upProToOss(file, { product: 'wholesale-business' }).then(res => {
        this.fileList02 = []
        this.fileList02.push({ url: res, isImage: true })
        this.$set(this.certificationForm, 'vetLicense', res || '')
      })
    },
    // 提交
    onSubmit(values) {
      this.loading = true
      addEnterprise(this.certificationForm).then(res => {
        this.$toast({ message: '已提交审核！', duration: 3 * 1000 })
        this.step = 2
        this.loading = false
      })
    },
    // 重新提交
    resubmit() { this.step = 1 }
  }
}
</script>
<style lang="scss">
body {
  background: #f7f7f7;
}
</style>
